import { RichText, RichTextBlock } from 'prismic-reactjs';
import { serviceHtmlSerializer } from '../../../utils/htmlSerializers/serviceHtmlSerializer';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import {
  LinkMore,
  LinkText,
  ServiceContent,
  ServiceScrollAnchor,
  ServiceTitle,
} from './service.style';

export interface IServiceProps {
  offset: number;
  title: Array<RichTextBlock>;
  content: Array<RichTextBlock>;
  navigationItems: Array<RichTextBlock>[];
  service_link: Array<RichTextBlock>;
  service_list: Array<RichTextBlock>;
  animation_link: RichTextBlock;
  activeStep: boolean;
}

export const Service = ({
  title,
  content,
  service_link,
  service_list,
  navigationItems,
  animation_link,
  activeStep,
}: IServiceProps) => {
  const refDesktop = useRef<any>(null);
  const refMobile = useRef<any>(null);

  useEffect(() => {
    import('@lottiefiles/lottie-player');
  }, []);

  useEffect(() => {
    const mobileLottie = refMobile.current?.getLottie?.();
    const desktopLottie = refDesktop.current?.getLottie?.();
    if (activeStep && mobileLottie?.goToAndPlay && desktopLottie?.goToAndPlay) {
      mobileLottie.goToAndPlay(0, true);
      desktopLottie.goToAndPlay(0, true);
    }
  }, [activeStep]);

  return (
    <div className="service" key={RichText.asText(title)}>
      <ServiceScrollAnchor id={service_link as unknown as string} />
      <div className="service__image mobile">
        <lottie-player
          ref={refMobile}
          autoplay
          mode="normal"
          class="service__lottie"
          id={RichText.asText(title)}
          src={animation_link.url}
        />
      </div>
      <ServiceContent>
        <ServiceTitle>{RichText.asText(title)}</ServiceTitle>
        <RichText render={content} htmlSerializer={serviceHtmlSerializer} />
        {service_link && RichText.asText(service_link) !== 'empty' && (
          <LinkMore href={`${service_link}`}>
            <LinkText>More</LinkText>
            <svg
              width="21"
              height="12"
              viewBox="0 0 21 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 6H19.5M19.5 6L14.5 1M19.5 6L14.5 11"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </LinkMore>
        )}
      </ServiceContent>
      <div className="service__right-container">
        <div className="service__image desktop">
          <lottie-player
            ref={refDesktop}
            autoplay
            mode="bounce"
            class="service__lottie"
            id={RichText.asText(title)}
            src={animation_link.url}
          />
        </div>
        <RichText
          render={service_list}
          htmlSerializer={serviceHtmlSerializer}
        />
      </div>
    </div>
  );
};
